module.exports = {
  'Nurse':'Nurse',
  'Physician':'Physician',
  'Pharmacist ':'Pharmacist ',
  'Radiologist':'Radiologist',
  'Lab Specialist':'Lab Specialist',
  'Safety Officer':'Safety Officer',
  'Security Officer':'Security Officer',
  'Technician':'Technician',
  'Administrative Employee':'Administrative Employee',
  'Medical Record Staff':'Medical Record Staff',
  'Information technology':'Information technology',
  'Social Worker':'Social Worker',
  'Trainee':'Trainee',
  'dietitians':'dietitians',
  'occupational therapists':'occupational therapists',
  'physiotherapists':'physiotherapists',
  'clinical assistants ':'clinical assistants ',
  'patient services Officer':'patient services Officer',
  'porters ':'porters ',
  'volunteer':'volunteer',
  'ward clerk':'ward clerk',
  'housekeeping':'housekeeping',
  'paramedic ':'paramedic '
};
